<template>
	<div class="order-details">
		<!-- 给header上与data上加on为退款订单-->
		<div class="header bg-color-red acea-row row-middle" :class="refundOrder ? 'on' : ''">
			<div class="pictrue" v-if="!refundOrder">
				<div v-if="orderInfo.shipping_type == 4"
					style="width:100%;height:100%;background:#E93323;position: relative;overflow: hidden;">
					<img src="http://app.funengtuan.com/imgs/quan.png" class="quan" />
					<img src="http://app.funengtuan.com/imgs/modi.png" class="modi" style="position: absolute;" />
				</div>
				<img :src="orderInfo.status_pic" v-else />
			</div>
			<div class="data" :class="refundOrder ? 'on' : ''">
				<div class="state">
					<span v-if="
              orderInfo.is_judge == 1 &&
                (orderInfo.judge_status == 3 || orderInfo.judge_status == 5)
            ">审方失败,</span>{{ orderInfo._status._msg }}
				</div>
				<div>
					{{ orderInfo.add_time_y
          }}<span class="time">{{ orderInfo.add_time_h }}</span>
				</div>
			</div>

			<div class="ewm_btn" @click="ewm_show()">
				<img src="../../assets/images/ewm.png" mode="" />
			</div>
		</div>
		<template v-if="!refundOrder">
			<div class="nav">
				<div class="navCon acea-row row-between-wrapper"
					v-if="orderInfo.is_judge === 1 && orderInfo.refund_status == 0">
					<div :class="{ on: status.type === 0 || status.type === 9 }">
						待付款
					</div>
					<div :class="{ on: orderInfo.judge_status == 0 && status.type === 1 }"
						v-if="orderInfo.judge_status == 0 && status.type === 1">
						待申请开方
					</div>
					<div :class="{ on: orderInfo.judge_status == 1 && status.type === 1 }"
						v-else-if="orderInfo.judge_status == 1 && status.type === 1">
						医师开方中
					</div>
					<div :class="{ on: orderInfo.judge_status == 2 && status.type === 1 }"
						v-else-if="orderInfo.judge_status == 2 && status.type === 1">
						药师审方中
					</div>
					<div :class="{ on: orderInfo.judge_status == 4 && status.type === 1 }"
						v-else-if="orderInfo.judge_status == 4 && status.type === 1">
						待发货
					</div>
					<div :class="{ on: orderInfo.judge_status == 3 && status.type === 1 }"
						v-else-if="orderInfo.judge_status == 3 && status.type === 1">
						医师拒绝
					</div>
					<div :class="{ on: orderInfo.judge_status == 5 && status.type === 1 }"
						v-else-if="orderInfo.judge_status == 5 && status.type === 1">
						药师拒绝
					</div>
					<div :class="{ on: status.type === 1 }" v-else>待发货</div>
					<div :class="{ on: status.type === 2 }">待收货</div>
					<div :class="{ on: status.type === 3 }">待评价</div>
					<div :class="{ on: status.type === 4 }">已完成</div>
				</div>
				<div class="navCon acea-row row-between-wrapper" v-else>
					<div :class="{ on: status.type === 0 || status.type === 9 }">
						待付款
					</div>
					<div :class="{ on: status.type === 1 }">待发货</div>
					<div :class="{ on: status.type === 2 }">待收货</div>
					<div :class="{ on: status.type === 3 }">待评价</div>
					<div :class="{ on: status.type === 4 }">已完成</div>
				</div>
				<div class="progress acea-row row-between-wrapper" v-if="orderInfo.is_judge === 1">
					<div class="iconfont" :class="[
              status.type === 0 || status.type === 9
                ? 'icon-webicon318'
                : 'icon-yuandianxiao',
              status.type >= 0 ? 'font-color-red' : ''
            ]"></div>
					<div class="line" :class="{ 'bg-color-red': status.type > 0 && status.type != 9 }"></div>
					<div class="iconfont" :class="[
              status.type === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 1 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="line" :class="{
              'bg-color-red':
                status.type > 1 && status.type != 6 && status.type != 9
            }"></div>
					<div class="iconfont icon-yuandianxiao" :class="[
              status.type === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 2 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="line" :class="{
              'bg-color-red':
                status.type > 2 && status.type != 6 && status.type != 9
            }"></div>
					<div class="iconfont icon-yuandianxiao" :class="[
              status.type === 3 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 3 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="line" :class="{
              'bg-color-red':
                status.type > 3 && status.type != 6 && status.type != 9
            }"></div>
					<div class="iconfont icon-yuandianxiao" :class="[
              status.type == 4 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 4 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="judge_title">
						<div v-if="orderInfo.judge_status == 1">
							医师开方中，预计<span>3</span>分钟
						</div>
						<div v-else-if="orderInfo.judge_status == 2">
							药师审方中，预计<span>3</span>分钟
						</div>
						<div v-else-if="orderInfo.judge_status == 4">审方通过</div>
						<div v-else-if="orderInfo.judge_status == 3">医师拒绝</div>
						<div v-else-if="orderInfo.judge_status == 5">药师拒绝</div>
					</div>
				</div>
				<!-- ***************************************************************************** -->
				<div class="progress acea-row row-between-wrapper" v-else>
					<div class="iconfont" :class="[
              status.type === 0 || status.type === 9
                ? 'icon-webicon318'
                : 'icon-yuandianxiao',
              status.type >= 0 ? 'font-color-red' : ''
            ]"></div>
					<div class="line" :class="{ 'bg-color-red': status.type > 0 && status.type != 9 }"></div>
					<div class="iconfont" :class="[
              status.type === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 1 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="line" :class="{
              'bg-color-red':
                status.type > 1 && status.type != 6 && status.type != 9
            }"></div>
					<div class="iconfont icon-yuandianxiao" :class="[
              status.type === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 2 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="line" :class="{
              'bg-color-red':
                status.type > 2 && status.type != 6 && status.type != 9
            }"></div>
					<div class="iconfont icon-yuandianxiao" :class="[
              status.type === 3 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 3 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
					<div class="line" :class="{
              'bg-color-red':
                status.type > 3 && status.type != 6 && status.type != 9
            }"></div>
					<div class="iconfont icon-yuandianxiao" :class="[
              status.type == 4 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 4 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"></div>
				</div>
			</div>
			<div class="address">
				<div class="name">
					{{ orderInfo.real_name
          }}<span class="phone">{{ orderInfo.user_phone }}</span>
				</div>
				<div>{{ orderInfo.user_address }}</div>
			</div>
			<div class="line"><img src="@assets/images/line.jpg" /></div>
		</template>
		<OrderGoods :evaluate="status.type || 0" :cartInfo="orderInfo.cartInfo || []" :oid="orderInfo.id"
			:pay_price="orderInfo.pay_price || []" :orderInfo="orderInfo"></OrderGoods>
		<div class="wrapper">
			<div class="item acea-row row-between">
				<div>订单编号：</div>
				<div class="conter acea-row row-middle row-right" style="width: 75%;">
					{{ orderInfo.order_id
          }}<span class="copy copy-data" :data-clipboard-text="orderInfo.order_id">复制</span>
				</div>
			</div>
			<div class="item acea-row row-between">
				<div>下单时间：</div>
				<div class="conter">
					{{ orderInfo.add_time_y + " " + orderInfo.add_time_h }}
				</div>
			</div>
			<div class="item acea-row row-between">
				<div>订单类型：</div>
				<die class="conter" v-if="orderInfo.shipping_type == 4">
					闪送订单
				</die>
				<div class="conter" v-else>
					{{ orderTypeName }}
				</div>
			</div>
			<div class="item acea-row row-between">
				<div>支付状态：</div>
				<div class="conter">{{ orderInfo.paid ? "已支付" : "未支付" }}</div>
			</div>
			<div class="item acea-row row-between">
				<div>支付方式：</div>
				<div class="conter">{{ orderInfo._status._payType }}</div>
			</div>
			<div class="item acea-row row-between" v-if="orderInfo.mark">
				<div>买家留言：</div>
				<div class="conter">{{ orderInfo.mark }}</div>
			</div>
		</div>

		<div v-if="orderInfo.status != 0">
			<div class="wrapper" v-if="orderInfo.delivery_type === 'express'">
				<div class="item acea-row row-between">
					<div>配送方式：</div>
					<div class="conter">
						发货
					</div>
				</div>
				<div class="item acea-row row-between">
					<div>快递公司：</div>
					<div class="conter">{{ orderInfo.delivery_name || "" }}</div>
				</div>
				<div class="item acea-row row-between">
					<div>快递号：</div>
					<div class="conter">{{ orderInfo.delivery_id || "" }}</div>
				</div>
			</div>
			<div class="wrapper" v-else-if="orderInfo.shipping_type==4">
				<div class="item acea-row row-between">
					<div>配送方式：</div>
					<div class="conter">
						闪送
					</div>
				</div>
			</div>
			<div class="wrapper" v-else>
				<div class="item acea-row row-between">
					<div>配送方式：</div>
					<div class="conter">
						送货
					</div>
				</div>
				<div class="item acea-row row-between">
					<div>配送人：</div>
					<div class="conter">{{ orderInfo.delivery_name || "" }}</div>
				</div>
				<div class="item acea-row row-between">
					<div>配送电话：</div>
					<div class="conter acea-row row-middle row-right">
						{{ orderInfo.delivery_id || "" }}<span class="copy">拨打</span>
					</div>
				</div>
			</div>
		</div>
		<!--     退款订单详情 -->
		<div class="wrapper" v-if="refundOrder">
			<div class="item acea-row row-between">
				<div>收货人：</div>
				<div class="conter">{{ orderInfo.real_name }}</div>
			</div>
			<div class="item acea-row row-between">
				<div>联系电话：</div>
				<div class="conter">{{ orderInfo.user_phone }}</div>
			</div>
			<div class="item acea-row row-between">
				<div>收货地址：</div>
				<div class="conter">{{ orderInfo.user_address }}</div>
			</div>
		</div>
		<div class="wrapper">
			<div class="item acea-row row-between">
				<div>商品总金额：</div>
				<div class="conter">￥{{ orderInfo.total_price }}</div>
			</div>
			<div class="item acea-row row-between" v-if="orderInfo.coupon_price > 0">
				<div>优惠券抵扣：</div>
				<div class="conter">-￥{{ orderInfo.coupon_price }}</div>
			</div>
			<div class="item acea-row row-between" v-if="orderInfo.use_integral > 0">
				<div>积分抵扣：</div>
				<div class="conter">-￥{{ orderInfo.deduction_price }}</div>
			</div>
			<div class="item acea-row row-between" v-if="orderInfo.pay_postage > 0 && orderInfo.shipping_type == 1">
				<div>运费：</div>
				<div class="conter">￥{{ orderInfo.pay_postage }}</div>
			</div>
			<div class="item acea-row row-between" v-if="orderInfo.pay_postage > 0 && orderInfo.shipping_type == 4">
				<div>闪送费用：</div>
				<div class="conter">￥{{ orderInfo.pay_postage }}</div>
			</div>
			<div class="actualPay acea-row row-right">
				实付款：<span class="money font-color-red">￥{{ orderInfo.pay_price }}</span>
			</div>
		</div>
		<!-- 		<div class="wrapper" v-if="orderInfo.is_judge === 1 && orderInfo.judge_status == 4">
			<div class="bnt bg-color-red" style="width: auto;padding: 0 3%;">
				
			</div>
		</div> -->
		<div style="height:1.2rem;" v-if="!refundOrder && offlineStatus"></div>
		<div class="footer acea-row row-right row-middle" v-if="!refundOrder && offlineStatus">
			<!-- 	<template v-if="orderInfo.is_judge === 1 && orderInfo.judge_status == 4">
				<a :href="orderInfo.rpUrl" class="bnt bg-color-red" style="width:auto;padding:0 1%">查看并下载处方</a>
			</template> -->
			<template v-if="status.type === 0">
				<div class="bnt cancel" @click="cancelOrder">取消订单</div>
				<div class="bnt bg-color-red" @click="payzhifu">立即付款</div>
			</template>
			<template v-if="status.type === 1">
				<div class="bnt cancel" @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })"
					v-if="orderInfo.judge_status != 1 && orderInfo.judge_status < 3">
					申请退款
				</div>
				<div class="bnt bg-color-red" v-if="orderInfo.is_judge === 1 && orderInfo.judge_status == 0"
					@click="gojudge">
					申请开方
				</div>
			</template>
			<template v-if="status.type === 2 && (orderInfo.shipping_type == 3 || orderInfo.shipping_type == 4)">
				<div class="bnt bg-color-red" @click="lookWei(orderInfo.order_id)" >
					骑手位置
				</div>
				<div class="bnt bg-color-red" @click="callPhone(orderInfo.order_id)" >
					联系骑手
				</div>
				<div class="bnt bg-color-red" @click="callPhone2(orderInfo.merchant_phone)" >
					联系商家
				</div>
				<div class="bnt bg-color-red" @click="takeOrder(order)" >
					确认收货
				</div>
			</template>
			<template v-if="
          status.type === 2 &&
            (orderInfo.shipping_type != 3 && orderInfo.shipping_type != 4)
        ">
				<div class="bnt default" @click="
            $router.push({ path: '/order/logistics/' + orderInfo.order_id })
          ">
					查看物流
				</div>
				<div class="bnt bg-color-red" @click="takeOrder">
					确认收货
				</div>
			</template>
			<template v-if="status.type === 3 && orderInfo.delivery_type === 'express'">
				<div class="bnt default" @click="
            $router.push({ path: '/order/logistics/' + orderInfo.order_id })
          ">
					查看物流
				</div>
			</template>
			<template v-if="status.type === 4">
				<div class="bnt cancel" @click="delOrder">
					删除订单
				</div>
				<div class="bnt default" @click="
            $router.push({ path: '/order/logistics/' + orderInfo.order_id })
          ">
					查看物流
				</div>
			</template>
			<template v-if="status.type === 6">
				<div class="bnt bg-color-red" @click="
            $router.push({ path: '/activity/group_rule/' + orderInfo.pink_id })
          ">
					查看拼团
				</div>
			</template>
		</div>

		<Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>

		<div class="ewm" v-if="ewmShow" @touchmove.stop.prevent catchtouchmove="true">
			<div class="mask" @click="ewm_show()"></div>
			<div class="body">
				<img :src="'https://api.pwmqr.com/qrcode/create/?url=' + ewmData" mode="" />
			</div>
		</div>
		<div class="dialog" v-show="showMask == 'true'"
			style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0.3);z-index: 10;">
			<div class="dialog-container"
				style="position: absolute;top:30%;width:80%;left:10%;right:10%;background:#fff;padding:5%;border-radius:10px;">
				<div class="dialog-content" style="font-size:0.3rem;text-align:center;margin-bottom:20px">
					您选择的药品中含有处方药,请填写开方信息
				</div>
				<div class="btns" style="display: flex;justify-content: space-around;">
					<div class="settlement" @click="closeBtn" style="background:rgb(230, 233, 241);">
						暂不填写
					</div>
					<div class="settlement" @click="confirmBtn" style="background:#337f04;color:#fff">
						去填写
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import pdf from "vue-pdf";
	import OrderGoods from "@components/OrderGoods";
	import {
		orderDetail
	} from "@api/order";
	import ClipboardJS from "clipboard";
	import Payment from "@components/Payment";
	import {
		isWeixin
	} from "@utils";
	import {
		mapGetters
	} from "vuex";
	import {
		cancelOrderHandle,
		takeOrderHandle,
		delOrderHandle,
		payOrderHandle
	} from "@libs/order";
	import {
		getIntegralPay,
		getnethosp
	} from "@api/store";
	import axios from "axios";
	const NAME = "OrderDetails";

	export default {
		name: NAME,
		components: {
			OrderGoods,
			Payment,
			pdf
		},
		props: {},
		data: function() {
			return {
				showMask: false,
				ewmShow: false,
				ewmData: "",
				offlinePayStatus: 2,
				orderTypeName: "普通订单",
				orderTypeNameStatus: true,
				offlineStatus: true,
				id: this.$route.params.id,
				orderInfo: {
					_status: {}
				},
				status: {},
				pay: false,
				payType: ["yue", "weixin", "integral"],
				from: isWeixin() ? "weixin" : "weixinh5"
			};
		},
		computed: {
			refundOrder() {
				return this.orderInfo.refund_status > 0;
			},
			...mapGetters(["userInfo"])
		},
		watch: {
			$route(n) {
				if (n.name === NAME && this.id !== n.params.id) {
					this.id = n.params.id;
					this.getDetail();
				}
			}
		},
		inject: ["app"],
		mounted: function() {
			console.log(this.$router.options);
			this.getDetail();
			this.$nextTick(function() {
				var copybtn = document.getElementsByClassName("copy-data");
				const clipboard = new ClipboardJS(copybtn);
				clipboard.on("success", () => {
					this.$dialog.success("复制成功");
				});
			});
		},
		methods: {
			// 查看骑手位置
			lookWei(a) {
				console.log(123123123);
				window.location.href =
					"https://app.funengtuan.com/map.html?ordersid=" + a;
			},
			callPhone(id) {
				let that = this;
				axios
					.post(
						"https://app.funengtuan.com/api/meituan/delivery_get_order_info/" + id
					)
					.then(function(response) {
						console.log(response);
						if (response.data.data.data.courier_phone) {
							window.location.href =
								"tel://" + response.data.data.data.courier_phone;
						} else {
							return that.$dialog.toast({
								mes: "暂无骑手哦"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
				// var a = Math.floor(Math.random() * 10); //可均衡获取0到9的随机整数。
				// var b = [
				//   "17735188818",
				//   "19935343434",
				//   "19903518288",
				//   "19903518118",
				//   "17735188816",
				//   "19935343435",
				//   "19903518284",
				//   "19903518113",
				//   "17735188812",
				//   "19935343431"
				// ];
				// var c = b[a];
				// window.location.href = "tel://" + c;
			},
			callPhone2(tel) {
				window.location.href = "tel://" + tel;
			},
			payzhifu: function() {
				var order = this.orderInfo;
				// this.pay = true
				this.shipping_type = order.shipping_type;
				var that = this;
				if (order.is_judge == 1) {
					window.location.href =
						"http://sifei.funengtuan.com/api/integral_auth?orders_sn=" +
						order.order_id +
						"&back_url=" +
						window.location.host +
						"/order/list/0" +
						"&pay_type=vip";
					// window.location.href = "http://wx.dxkyyy.com/api/integral_auth?orders_sn=" + data.result.orderId +
					// 	"&back_url=" + window.location.host + '&pay_type=vip';
					return;
				}
				if (order.member_shop == 1) {
					// 积分商城支付
					window.location.href =
						"http://qqhy.funengtuan.com/api/integral_auth?orders_sn=" +
						order.order_id +
						"&back_url=" +
						window.location.host +
						"/order/list/0" +
						"&pay_type=integral";
					return;
				}
				if (order.cloud_mid !== 0) {
					// 云药库支付
					window.location.href =
						"http://xlx.funengtuan.com/api/integral_auth?orders_sn=" +
						order.order_id +
						"&back_url=" +
						window.location.host +
						"/order/list/0" +
						"&pay_type=integral";
					return;
				}
				if (
					!(
						order.combination_id > 0 ||
						order.bargain_id > 0 ||
						order.seckill_id > 0
					)
				) {
					that.setOfflinePayStatus(order.offlinePayStatus);
				}
				this.pay = true;
				// this.toPay = type => {
				// 	payOrderHandle(order.order_id, type, that.from)
				// 		.then(() => {
				// 			const type = parseInt(this.$route.params.type) || 0;
				// 			// that.changeType(type);
				// 			that.getDetail();
				// 		})
				// 		.catch(() => {
				// 			const type = parseInt(that.$route.params.type) || 0;
				// 			// that.changeType(type);
				// 			that.getDetail();
				// 		});
				// };
				// if(this.orderInfo.member_shop==1){
				// 	console.log(11111)
				// 	let data = {
				// 		uid:this.userInfo.uid,
				// 		orders_sn:this.orderInfo.order_id,
				// 		pay_type:"integral"
				// 	};
				// 	getIntegralPay(data).then(res => {
				// 		console.log(res)
				// 	})
				// 	.catch(err => {this.$dialog.error(err.msg);});
				// integral_pay
				// }else{
				//
				// }
			},
			ewm_show: function() {
				this.ewmShow = !this.ewmShow;
				let data = {
					order_id: this.orderInfo.order_id,
					type: "hexiao"
				};
				this.ewmData = encodeURI(JSON.stringify(data));
			},
			goBack() {
				const history = this.app.history,
					last = history[history.length - 1] || {};
				if (last.name === "MyOrder") return this.$router.go(-1);
				else
					return this.$router.replace({
						path: "/order/list/"
					});
			},
			closeBtn() {
				this.showMask = "false";
			},
			confirmBtn() {
				this.showMask = "false";
				this.$router.push({
					path: "/recipel?orderid=" + this.orderInfo.order_id
				});
			},
			gojudge() {
				this.showMask = "true";
			},
			cancelOrder() {
				cancelOrderHandle(this.orderInfo.order_id)
					.then(() => {
						setTimeout(() => this.goBack(), 300);
					})
					.catch(() => {
						this.getDetail();
					});
			},
			takeOrder() {
				takeOrderHandle(this.orderInfo.order_id).finally(() => {
					this.getDetail();
				});
			},
			delOrder() {
				delOrderHandle(this.orderInfo.order_id).then(() => {
					setTimeout(() => this.goBack(), 300);
				});
			},
			setOfflinePayStatus: function(status) {
				var that = this;
				that.offlinePayStatus = status;
				if (status === 1 && that.orderTypeNameStatus === true) {
					that.payType.push("offline");
				}
			},
			getOrderStatus: function() {
				let orderInfo = this.orderInfo || {},
					_status = orderInfo._status || {
						_type: 0
					},
					status = {};
				let type = parseInt(_status._type),
					delivery_type = orderInfo.delivery_type,
					seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
					bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
					combination_id = orderInfo.combination_id ?
					parseInt(orderInfo.combination_id) :
					0;
				status = {
					type: type,
					class_status: 0
				};
				if (type === 1 && combination_id > 0) {
					status.type = 6;
					status.class_status = 1;
				} //查看拼团
				if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
				if (type === 2) status.class_status = 3; //确认收货
				if (type === 4 || type === 0) status.class_status = 4; //删除订单
				if (
					!seckill_id &&
					!bargain_id &&
					!combination_id &&
					(type === 3 || type === 4)
				)
					status.class_status = 5; //再次购买
				if (type == 9) {
					//线下付款
					status.class_status = 0;
					this.offlineStatus = false;
				}
				this.status = status;
			},
			getDetail() {
				const id = this.id;
				if (!id) return this.$dialog.error("订单不存在");
				orderDetail(id)
					.then(res => {
						// console.log(res.data)
						this.orderInfo = res.data;
						if (
							this.orderInfo.is_judge === 1 &&
							this.orderInfo.judge_status == 0 &&
							this.orderInfo.paid == 1
						) {
							this.showMask = "true";
						}
						this.getOrderStatus();
						if (this.orderInfo.combination_id > 0) {
							this.orderTypeName = "拼团订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.bargain_id > 0) {
							this.orderTypeName = "砍价订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.seckill_id > 0) {
							this.orderTypeName = "秒杀订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.member_shop == 1) {
							this.orderTypeName = "积分订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.is_judge > 0) {
							this.orderTypeName = "处方订单";
							this.orderTypeNameStatus = false;
							if (
								this.orderInfo.judge_status == 1 ||
								this.orderInfo.judge_status == 2
							) {
								this.getshstatus(id);
							}
						} else if (this.orderInfo.shipping_type == 3) {
							this.orderTypeName = "闪送订单";
							this.orderTypeNameStatus = false;
						}
						this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
					})
					.catch(err => {
						this.$dialog.error(err.msg);
					});
			},
			async toPay(type) {
				var that = this;
				await payOrderHandle(this.orderInfo.order_id, type, that.from);
				that.getDetail();
			},
			getshstatus: function(id) {
				var that = this;
				let run = function() {
					getnethosp(id).then(res => {
						if (res.status == "200") {
							that.getnewdetail(id);
						}
					});
					return run;
				};
				setInterval(run(), 30000);
			},
			getnewdetail: function(id) {
				orderDetail(id)
					.then(res => {
						this.orderInfo = res.data;
						this.getOrderStatus();
						if (this.orderInfo.combination_id > 0) {
							this.orderTypeName = "拼团订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.bargain_id > 0) {
							this.orderTypeName = "砍价订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.seckill_id > 0) {
							this.orderTypeName = "秒杀订单";
							this.orderTypeNameStatus = false;
						} else if (this.orderInfo.is_judge > 0) {
							this.orderTypeName = "处方订单";
							this.orderTypeNameStatus = false;
						}
						this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
					})
					.catch(err => {
						this.$dialog.error(err.msg);
					});
			},
			nopay: function() {
				return this.$dialog.toast({
					mes: "请耐心等待医师开方"
				});
			}
		}
	};
</script>
<style>
	.order-details .footer .bg-color-red{
		width:1.55rem!important;
	}
	.quan {
		animation: rotate 2s linear infinite;
	}

	@keyframes rotate {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	.modi {
		animation: rotates 1.85s linear infinite;
	}

	@keyframes rotates {
		0% {
			left: -2.2rem;
		}

		25% {
			left: 0rem;
		}

		75% {
			left: 0rem;
		}

		100% {
			left: 2.2rem;
		}
	}

	.judge_title div {
		font-size: 0.3rem;
		width: 100%;
		margin: 10px;
	}

	.judge_title div span {
		color: coral;
	}

	.btns .settlement {
		font-size: 0.3rem;
		color: #000;
		width: 2.4rem;
		height: 0.7rem;
		text-align: center;
		line-height: 0.7rem;
	}

	.order-details .header {
		position: relative;
	}

	.order-details .header .ewm_btn {
		position: absolute;
		top: 20px;
		right: 15px;
		width: 20px;
		height: 20px;
	}

	.order-details .header .ewm_btn img {
		width: 100%;
		height: 100%;
	}

	.ewm {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 500;
	}

	.ewm .mask {
		background-color: transparent;
	}

	.ewm .body {
		box-shadow: 0 0 50px rgba(0, 0, 0, 0.6);
		background: #ffffff;
		border-radius: 15px;
		overflow: hidden;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 99;
	}

	.ewm .body img {
		width: 300px;
		height: 300px;
	}
</style>
